import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { SystemComponent } from './system.component';
import { TrackingComponent } from './tracking/tracking.component';
import { ReportsComponent } from './reports/reports.component';
import { DataReportComponent } from './data/data.component';
import { DiagnosticsComponent } from './diagnostics/diagnostics.component';
import { HistoryComponent } from './history/history.component';
import { ServiceComponent } from './service/service.component';
import { DriversComponent } from './drivers/drivers.component';
import { DispatcherComponent } from './dispatcher/dispatcher.component';
import { AdminPanelComponent } from './admin-panel/admin-panel.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { AuthGuard } from "./AuthGuard";
import { InterfacePermissions } from "../services/users.service";
import { TrackingMapOnlyComponent } from './tracking/map-only/map-only.component';
import { MobileSystemComponent } from './mobile-system/mobile-system.component';
import { MobileMapComponent } from './mobile-map/mobile-map.component';

const isMobile = (): boolean => {
  //return false;
  if (typeof navigator === 'undefined') return false; // for SSR safety
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );
};
let routes: Routes = [];
if (isMobile()) {
  routes =
    [{
      path: '',
      component: MobileSystemComponent,
      children: [
        {
          path: '',

          loadChildren: () =>
            import('./mobile-monitoring/mobile-monitoring.module')
              .then(m => m.MobileMonitoringModule),
          data: { access_requirement: InterfacePermissions.TRACKING }
        },
        {
          path: 'geozones',
          loadChildren: () =>
            import('./mobile-geozones/mobile-geozones.module')
              .then(m => m.MobileGeozonesModule)
        },
        {
          path: 'reports',
          loadComponent: () =>
            import('./mobile-reports/mobile-reports.component')
              .then(m => m.MobileReportsComponent)
        },
        // {
        //   path: 'history',
        //   loadChildren: () =>
        //     import('./object-history/object-history.module')
        //       .then(m => m.ObjectHistoryModule),
        //   data: { access_requirement: InterfacePermissions.HISTORY }
        // },
        {
          path: 'settings',
          loadChildren: () =>
            import('./mobile-settings/mobile-settings.module')
              .then(m => m.MobileSettingsModule)
        },
        {
          path: 'map',
          component: MobileMapComponent
        }
      ]
    },
    { path: '**', redirectTo: '/' }
    ];
}
else {
  routes = [
    {
      path: '',
      component: SystemComponent,
      children: [
        {
          path: '',
          component: TrackingComponent
        },
        {
          path: 'tracking',
          component: TrackingComponent
        },
        {
          path: 'dashboard',
          component: DashboardComponent,
          canActivate: [AuthGuard],
          data: { access_requirement: InterfacePermissions.ANALYTICS }
        },

        {
          path: 'history',
          component: HistoryComponent,
          canActivate: [AuthGuard],
          data: { access_requirement: InterfacePermissions.HISTORY }
        },
        {
          path: 'reports',
          component: ReportsComponent,
          canActivate: [AuthGuard],
          data: { access_requirement: InterfacePermissions.REPORTS }
        },
        {
          path: 'datainfo',
          component: DataReportComponent,
          canActivate: [AuthGuard],
          data: { access_requirement: InterfacePermissions.DATAINFO }
        },
        {
          path: 'diagnostics',
          component: DiagnosticsComponent,
          canActivate: [AuthGuard],
          data: { access_requirement: InterfacePermissions.DIAGNOSTICS }
        },
        {
          path: 'service', component: ServiceComponent,
          canActivate: [AuthGuard],
          data: { access_requirement: InterfacePermissions.SERVICE }
        },
        {
          path: 'drivers',
          component: DriversComponent,
          canActivate: [AuthGuard],
          data: { access_requirement: InterfacePermissions.DRIVERS }
        },
        {
          path: 'dispatcher',
          component: DispatcherComponent,
          canActivate: [AuthGuard],
          data: { access_requirement: InterfacePermissions.DISPATCHER }
        },
        {
          path: 'admin',
          component: AdminPanelComponent,
          canActivate: [AuthGuard],
          data: { access_requirement: InterfacePermissions.EDIT }
        },
      ]
    },
    {
      path: 'map',
      component: TrackingMapOnlyComponent
    },
    { path: '**', redirectTo: '/' }
  ];
}

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SystemRoutingModule {
}
